import React from 'react';
import ReactDOM from 'react-dom';

const rootElem = document.getElementById('root') as HTMLElement;

type ModalProps = {
  onClose: () => void;
  closeOnClickOutside?: boolean;
  modalStyle?: string;
};

const Modal: React.FC<ModalProps> = props => {
  const { onClose, closeOnClickOutside = false, modalStyle = '' } = props;

  const modal = (
    <div
      className={`fixed w-full h-full top-0 left-0 z-50 flex items-center justify-center`}>
      <div
        className={`fixed w-full h-full flex justify-center items-center top-0 left-0 bg-gray-800 opacity-75`}
        onClick={(): void => {
          if (closeOnClickOutside) onClose();
        }}></div>
      <div
        className={`fixed ui-card opacity-100 bg-white z-50 max-w-lg w-mSp ${modalStyle}`}>
        {props.children}
      </div>
    </div>
  );
  return ReactDOM.createPortal(modal, rootElem);
};

export default Modal;
